import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
import cn from './langs/cn';
import en from './langs/en';
import ms from './langs/ms';

Vue.use(VueI18n);

let language; // default locale

// 设置默认语言
if (localStorage.getItem('lang')) {
	language = localStorage.getItem('lang');
} else {
	language = 'zh_CN';
}
localStorage.setItem('lang', language);

const i18n = new VueI18n({
	locale: language,
	messages: {
		zh_CN: cn,
		en: en,
		ms: ms
	}
});

// 实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));

export function getI18nLocale() {
	return i18n.locale;
}

export function getI18nText(key) {
	return i18n.t(key);
}

export default i18n;
